import { useEffect, useState } from 'react';
import {
  collection,
  addDoc,
  query,
  orderBy,
  onSnapshot,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '../firebase';
import { getChatId } from '../utils/chatUtils';

export function usePromotionalChat(currentUserUid, promoProfileUid) {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const chatId = getChatId(currentUserUid, promoProfileUid);

  // Escuchar mensajes en tiempo real
  useEffect(() => {
    if (!chatId || !currentUserUid || !promoProfileUid) {
      return;
    }

    const messagesRef = collection(db, 'chatsPromotional', chatId, 'messages');
    const q = query(messagesRef, orderBy('createdAt', 'asc'));

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        setMessages(
          snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
        );
      },
      (err) => {
        setError('Error al cargar los mensajes.');
        console.error('Error en onSnapshot:', err);
      }
    );

    return () => unsubscribe();
  }, [chatId, currentUserUid, promoProfileUid]);

  const sendMessage = async (text) => {
    if (!text?.trim()) {
      setError('El mensaje no puede estar vacío.');
      return;
    }
    if (!currentUserUid || !promoProfileUid) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const chatRef = doc(db, 'chatsPromotional', chatId);
      const chatDoc = await getDoc(chatRef);
      const readStatusUpdate = {
        [currentUserUid]: true,
        [promoProfileUid]: false,
      };

      // Crear o actualizar el documento del chat
      if (!chatDoc.exists()) {
        await setDoc(chatRef, {
          users: [currentUserUid, promoProfileUid],
          createdAt: serverTimestamp(),
          lastMessage: text,
          lastMessageTimestamp: serverTimestamp(),
          readStatus: readStatusUpdate,
        });
      } else {
        await updateDoc(chatRef, {
          lastMessage: text,
          lastMessageTimestamp: serverTimestamp(),
          readStatus: readStatusUpdate,
        });
      }

      // Guardar el mensaje en la subcolección 'messages'
      await addDoc(collection(db, 'chatsPromotional', chatId, 'messages'), {
        attachments: [],
        createdAt: serverTimestamp(),
        read: false,
        sender: currentUserUid,
        text: text.trim(),
      });

      setLoading(false);
    } catch (err) {
      setError('Error al enviar el mensaje. Intenta de nuevo.');
      console.error('Error en sendMessage:', err);
      setLoading(false);
      throw err; // Lanzar error para que el componente pueda manejarlo
    }
  };

  return { messages, sendMessage, loading, error };
}